import { createApp } from "vue";
import { createPinia } from "pinia"; // Import createPinia
import App from "./App.vue";
import router from "./router";
import "./style.css"; // Your Tailwind CSS import

const app = createApp(App); // Create the app instance

app.use(createPinia()); // Tell the app to use Pinia
app.use(router); // Tell the app to use the router

app.mount("#app"); // Mount the app
